module.exports = __webpack_public_path__ + "img/coldcall_image4.38327dec.png";